<template>
    <header :class="['pane-section', collapsed ? 'collapsed' : '']">
        <section class="pane-section__header">
            <section class="pane-section--left" @click="collapsed = !collapsed">
                <button class="pane-section--icon">
                    <ui-icon :name="collapsed ? 'chevron-down' : 'chevron-up'" />
                </button>
                <section class="pane-section--title"><slot name="title" tag="span">{{ title }}</slot></section>
            </section>
            <section class="pane-section--right">
                <div class="hidden-when-collapsed">
                    <slot name="pane-header-right"></slot>
                    <ui-button title="View all" @click="onViewAll" v-if="typeof hasButton === 'undefined' || hasButton === true" />
                </div>
            </section>
        </section>
        <section :class="['pane-section__content', hasSlot ? 'has-slot' : '']">
            <slot>
                <ui-data-list
                    :header="tableHeader"
                    :preset="preset"
                    type="pane"
                    :tools="tools"
                    :itemCount="itemCount"
                    :maxItems="itemCountMax"
                    :minItems="itemCountMin"
                    :cache="false"
                    :includeInList="includeInList"
                />
            </slot>
        </section>
    </header>
</template>

<script>
    export default {
        name: 'pane-section',
        props: ['tools', 'title', 'preset', 'tableHeader', 'itemCount', 'itemCountMax', 'itemCountMin', 'hasButton', 'isCollapsed', 'includeInList'],
        data() {
            return {
                showSearchPane: true,
                collapsed: false,
            };
        },
        mounted() {
            if (typeof this.isCollapsed === 'boolean') {
                this.collapsed = this.isCollapsed;
            }
        },
        watch: {
            isCollapsed(val) {
                if (typeof val === 'boolean') {
                    this.collapsed = val;
                }
            }
        },
        computed: {
            content() {
                return this.tools.currentView.data.pane;
            },
            hasSlot() {
                return Object.keys(this.$slots).length;
            },
        },
        methods: {
            onViewAll() {
                const { tools } = this;

                // Show full list when clicking "Show all"
                if (tools.modifiers.currentShowAllBehavior === 'full_list') {
                    tools.changeView({
                        key: 'show-all-view',
                        title: this.title,
                        owner: tools.helpers.presetToKey(this.preset),
                        data: {
                            headerTitle: `${this.title}`,
                            headerSub: this.content.title,
                            preset: this.preset,
                        }
                    });
                } else if (tools.modifiers.currentShowAllBehavior === 'owner_home') {
                    const key = tools.helpers.presetToKey(this.preset);
                    const randomContent = tools.generator.randomContentOfType(this.preset);
                    const searchText = `${tools.currentPaneKey}-id:${randomContent.id ? randomContent.id : tools.randomizer.bb_pin()}`;
                    tools.changeView(
                        {
                            title: searchText,
                            key: `${key}-view`,
                            owner: key,
                            data: {
                                search: {
                                    show: true,
                                    value: searchText,
                                },
                                pane: randomContent,
                            },
                        },
                        // Callback
                        () => {
                            tools.actions.togglePane('preview', false);
                            tools.actions.togglePane('search', true);
                        }
                    );
                }
            },
        },
    };
</script>

<style>
.pane-content > .pane-section:first-child .pane-section__header {
    border-top: 0;
}

.pane-section{
    display: flex;
    width:100%;
    flex-flow: column;
}

.pane-section.collapsed .pane-section__content {
    height: 0;
    overflow: hidden;
    visibility: hidden;
    padding-bottom: 0;
}

.pane-section__content {
    padding-bottom: 15px;
}

.pane-section__header {
    margin: 0 10px;
    /*padding-bottom: 10px;*/
    /*width: 100%;*/
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid rgba(0,0,0,0.1);
    height: 38px;
    z-index: 25;
    position: relative;
}
.pane-section--left:hover {
    opacity: .8;
    cursor: pointer;
}

.pane-section--icon {
    font-size: 1em;
    justify-content: flex-start;
    color: rgba(0,0,0,0.5);
    padding:0;
    margin-right:3px;
}

.pane-section--title{
    color: rgba(0,0,0,0.5);
    font-size: 1.23em;
    letter-spacing: 0.02em;
    font-weight: bold;
    margin-left: 4px;
    margin-right: 4px;
    text-rendering: optimizeLegibility;
}

.pane-section--right{
    display:flex;
    justify-content: flex-end;
    flex: 0 1 auto;
    z-index: 50;
}

.pane-section--left{
    display:flex;
    align-items: center;
    flex: 1;
}


/**
 * Has slot
 */

    .pane-section__content.has-slot {
        padding-left: 32px;
    }

    /**
     * Nested pane-section
     */

        .pane-section__content.has-slot .pane-section__header {
            margin: 0 10px 0 0;
        }

        .pane-section__content.has-slot .pane-section__header {
            border-top: 0;
            height: 30px;
        }

        .pane-section__content.has-slot .pane-section--icon {
            font-size: .9em;
        }

        .pane-section__content.has-slot .pane-section--title {
            font-size: 1.1em;
        }


    .collapsed .hidden-when-collapsed button {
        display: none;
    }

</style>



// WEBPACK FOOTER //
// PaneSection.vue?d80844d4